module.exports = __webpack_public_path__ + "static/media/plan-wom-libre.5c2eaf59.svg";